/* src/app/Dashboard/namertune/namertune.component.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: Arial, sans-serif;
  background-color: #f4f6f9;
}
.add_content {
  background-color: cornflowerblue !important;
  width: 9% !important;
  margin-left: 15px;
  margin-top: 15px;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
  color: white !important;
}
.app_section {
  padding: 10px;
  font-weight: 600;
  border-bottom: 1px solid black;
}
.layout_btn {
  padding: 5px;
  border-radius: 5px;
  background: white;
  border: 2px solid gray;
  color: black;
  font-size: 15px;
}
.dashboard-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}
.site-title {
  font-size: 1.5em;
  color: #DC3232;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}
.logout {
  color: #fff;
  text-decoration: none;
  font-size: 0.9em;
}
.navbar {
  margin-bottom: -35px;
  display: flex;
  background-color: #E2E2E2;
  top: 50px;
  width: 100%;
  z-index: 999;
  justify-content: flex-start;
}
.nav-item {
  position: relative;
  margin: 0 20px;
  font-size: 15px;
}
input {
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.nav-item > a {
  color: black;
  text-decoration: none;
  padding: 10px 15px;
  font-size: 1em;
  display: inline-block;
  cursor: pointer;
}
.main {
  padding: 25px;
  padding-top: 0px;
}
.dropdown {
  display: none;
  position: absolute;
  top: 100%;
  background-color: white;
  left: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  border-radius: 4px;
  min-width: 150px;
  z-index: 1001;
}
.nav-item:hover .dropdown {
  display: block;
}
.dropdown a {
  color: black;
  padding: 8px 15px;
  text-decoration: none;
  display: block;
}
.dropdown a:hover {
  background-color: lightgray;
}
.table-container {
  margin-top: 125px;
  border: 1px solid gray;
  border-radius: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.table-header h2 {
  font-size: 1.25em;
  font-weight: bold;
}
.btn-create {
  padding: 8px 16px;
  background-color: white;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  background: #F5F5F5;
  border-radius: 20px 0px 0px 0px !important;
}
.search_table {
  padding-right: 10px;
}
.table-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 23px;
  padding-left: 15px;
  margin-bottom: -5px !important;
}
.table-controls label {
  margin-right: 5px;
  font-size: 0.9em;
}
.table-controls input {
  padding: 5px;
  font-size: 0.9em;
  border: 1px solid black;
  border-radius: 4px;
}
.publisher-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
  border-bottom: 1px solid black;
}
.publisher-table th,
.publisher-table td {
  padding: 5px;
  text-align: left;
  font-size: 15px;
  cursor: default;
  border: 1px solid black !important;
  font-size: 15px !important;
}
.publisher-table th {
  background-color: cornflowerblue;
  color: black;
  font-size: 15px !important;
}
.publisher-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.pagination-controls button {
  padding: 8px;
  color: black;
  border: none;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
}
.pagination-controls button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}
.modal-content {
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background: none !important;
  box-shadow: none !important;
  border: none !important;
}
.modal-header {
  color: black;
  padding: 10px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.modal-title {
  font-size: 1.25em;
  font-weight: 400;
}
.btn-close:focus {
  box-shadow: none !important;
}
.btn-close {
  border: none;
  font-size: 15px;
  color: black;
  margin-right: 5px;
}
.form-label {
  font-weight: 600;
  color: #333;
}
.form-control {
  padding: 8px !important;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease-in-out;
  font-size: 15px;
  padding: 10px;
}
.form-control:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.2);
}
.modal-footer {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  border-top: none;
  margin-top: -20px;
}
.btn-primary {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 1em;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.btn-secondary {
  background-color: #6c757d;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}
.btn-secondary:hover {
  background-color: #5a6268;
}
.music-add-container {
  max-width: 100%;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}
h2 {
  margin-bottom: 20px;
  color: #333;
}
.section-header {
  font-size: 1.1em;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #555;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
.form-control {
  width: 445px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
input[type=file] {
  border: none;
  font-size: 15px;
  margin-left: -10px;
  margin-bottom: 0px;
}
.file-upload {
  position: relative;
  margin-bottom: 15px;
  width: 20vw;
}
.file-input {
  opacity: 0;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.n_btn {
  margin-right: 10px !important;
  padding: 5px !important;
  background-color: white !important;
  color: black !important;
  border: 1px solid !important;
}
.drag-drop-area {
  position: relative;
  width: 50%;
  height: 130px;
  border: 2px dashed #aaa;
  border-radius: 4px;
  text-align: center;
  line-height: 115px;
  color: #aaa;
  font-size: 15px;
  margin-top: 15px;
}
.note p {
  font-weight: bold;
}
.note ul {
  margin-top: 0;
  padding-left: 20px;
  color: #666;
  font-size: 15px;
}
.drm-checkbox {
  display: flex;
  align-items: center;
}
.drm-checkbox label {
  margin-left: 10px;
}
.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.btn {
  padding: 8px 12px;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-primary {
  background-color: #007bff;
  color: white;
}
.btn-secondary {
  background-color: #6c757d;
  color: white;
}
.btn:hover {
  opacity: 0.9;
}
.section-divider {
  display: block;
  border-bottom: 1px solid lightgray;
  margin: 5px 0;
  width: 100%;
  margin-bottom: 25px;
}
.section-dividers {
  display: block;
  border-bottom: 1px solid lightgray;
  margin: 5px 0;
  width: 100%;
}
.search_opt {
  width: 11vw;
  margin-right: 15px;
  margin-left: 13px;
  height: 5vh;
  padding: 5px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 400;
}
.pagination-info {
  margin-bottom: 10px;
  font-size: 15px;
}
.pagination-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}
.pagination-controls button {
  padding: 6px 12px;
  font-size: 15px;
}
.pagination-controls button.active {
  font-weight: bold;
  color: black;
}
.pagination-controls button:disabled {
  color: black;
  background-color: white;
  background: lightgray;
  cursor: default;
}
.pagination-controls button:hover {
  color: white !important;
  border: 1px solid #111111;
  background-color: #585858;
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #585858), color-stop(100%, #111111));
  background: -webkit-linear-gradient(top, #585858 0%, #111111 100%);
  background: -moz-linear-gradient(top, #585858 0%, #111111 100%);
  background: -ms-linear-gradient(top, #585858 0%, #111111 100%);
  background: -o-linear-gradient(top, #585858 0%, #111111 100%);
  background:
    linear-gradient(
      to bottom,
      #585858 0%,
      #111111 100%);
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 25px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #4caf50;
}
input:checked + .slider:before {
  transform: translateX(26px);
}
table,
th,
td {
  border: 1px solid lightgray !important;
}
th,
td {
  padding: 8px;
  text-align: left;
}
.eye:active {
  color: black !important;
  background-color: transparent !important;
}
.eye:hover {
  color: black !important;
  background-color: transparent !important;
}
.publisher-table tr {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1) !important;
  margin-bottom: 10px !important;
  border: 1px solid black;
}
.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1) !important;
  margin-bottom: 10px !important;
}
.cdk-drag-preview {
  background-color: skyblue !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2) !important;
  padding: 0px !important;
  overflow: hidden;
  margin: 30px !important;
}
.drag-handle {
  display: flex !important;
  align-items: center !important;
  cursor: grab !important;
  text-align: center;
  gap: 30 !important;
  margin: 30px !important;
}
.drag-handle .handle {
  margin-right: 5px !important;
  margin: 30px !important;
}
.cdk-drag-placeholder {
  opacity: 0 !important;
  margin: 30px !important;
}
.col-xs {
  width: 2% !important;
  margin: 30px !important;
}
.col-sm {
  width: 10% !important;
  margin: 30px !important;
}
.col-md {
  width: 20% !important;
  margin: 30px !important;
}
.cdk-drag {
  border: 1px dashed #90caf9 !important;
  margin: 30px !important;
}
.cdk-drag-preview td {
  display: table-cell !important;
  padding: 10px !important;
  margin: 30px !important;
}
.cdk-drag-preview .col-xs,
.cdk-drag-preview .col-sm,
.cdk-drag-preview .col-md {
  width: auto !important;
  text-align: center !important;
  margin: 30px !important;
}
table {
  width: 100%;
}
.publisher-table tr {
  cursor: move;
  border: 1px solid black;
}
.publisher-table cdk-drag-placeholder {
  background-color: lightgray;
}
.publisher-table cdk-drag-animating {
  transition: transform 0.2s ease;
}
.publisher-table td {
  padding: 8px 12px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-family: Arial, sans-serif;
}
th,
td {
  padding: 12px;
  text-align: left;
  border: 1px solid #f1f1f1;
}
th {
  background-color: #007bff;
  color: white;
  font-size: 15px;
  font-weight: bold;
}
tr:nth-child(even) {
  background-color: #f9f9f9;
}
tr:hover {
  background-color: #e2f2ff;
}
td {
  font-size: 15px;
  color: black;
}
td span {
  cursor: pointer;
}
td span:hover {
  text-decoration: underline;
}
.table-controls {
  margin-bottom: 15px;
}
.table-controls select,
.table-controls input {
  padding: 5px;
  font-size: 15px;
  margin-right: 10px;
  border-radius: 4px;
}
.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}
.pagination-controls button {
  padding: 8px 12px;
  background-color: #007bff;
  color: black;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.pagination-controls button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}
.pagination-controls span {
  font-size: 15px;
  color: #333;
}
.pagination-controls button:hover {
  background-color: #0056b3;
}
.table-container {
  width: fit-content;
  min-width: 100%;
}
.table-header {
  cursor: default;
  border-radius: 20px 20px 0px 0px !important;
}
.publisher-table {
  width: 100%;
  border-collapse: collapse;
}
.publisher-table th,
.publisher-table td {
  border: 1px solid black;
  text-align: center;
  padding: 8px;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: center;
}
thead th {
  border-bottom: 2px solid black;
}
.form-group {
  margin-top: 20px;
  gap: 15px;
}
.filter-label {
  font-size: 15px;
  margin-bottom: 5px;
  font-weight: bold;
}
.filter-select,
.filter-input {
  width: 200px;
  margin-right: 15px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.btn {
  cursor: pointer;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 15px;
}
.filter-btn {
  background-color: #007bff;
  color: white;
  transition: background-color 0.3s, transform 0.2s;
}
.filter-btn:hover {
  background-color: #0056b3;
}
.filter-btn:active {
  transform: scale(0.95);
}
.reset-btn {
  background-color: #dc3545;
  color: white;
  transition: background-color 0.3s, transform 0.2s;
}
.reset-btn:hover {
  background-color: #a71d2a;
}
.reset-btn:active {
  transform: scale(0.95);
}
.text-danger {
  display: grid;
  font-size: 15px;
}
angular2-multiselect {
  display: block;
  z-index: 1000;
}
.dropdown-list {
  max-height: 250px;
  overflow-y: auto;
}
.custom-btn-logout {
  margin-right: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 15px;
  border-radius: 20px;
  background:
    linear-gradient(
      145deg,
      #34d058,
      #28a745);
  color: white;
  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  outline: none;
  text-align: center;
}
.custom-btn-logout:hover {
  background:
    linear-gradient(
      145deg,
      #28a745,
      #34d058);
  box-shadow: 0 8px 16px rgba(40, 167, 69, 0.4);
  border-color: #1e7e34;
  transform: translateY(-3px);
}
.custom-btn-logout:focus {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.custom-btn-change-password,
.custom-btn-cancel {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 15px;
  border-radius: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  border: none;
  outline: none;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}
.custom-btn-change-password {
  background:
    linear-gradient(
      145deg,
      #87ceeb,
      #00bfff);
  color: white;
}
.custom-btn-change-password:hover {
  background:
    linear-gradient(
      145deg,
      #00bfff,
      #87ceeb);
  box-shadow: 0 8px 16px rgba(0, 191, 255, 0.4);
  transform: translateY(-3px);
}
.custom-btn-change-password:focus,
.custom-btn-cancel:focus {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.modal-footer {
  margin-bottom: 15px !important;
}
.custom-btn-filter,
.custom-btn-reset {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  border-radius: 20px !important;
  padding: 10px 20px !important;
  transition: all 0.3s ease !important;
  cursor: pointer !important;
  outline: none !important;
  text-align: center !important;
  border: none !important;
}
.custom-btn-filter {
  background:
    linear-gradient(
      145deg,
      #74b9ff,
      #a2d9ff) !important;
  color: white !important;
  box-shadow: 0 6px 12px rgba(116, 185, 255, 0.3) !important;
}
.custom-btn-filter:hover {
  background:
    linear-gradient(
      145deg,
      #a2d9ff,
      #74b9ff) !important;
  box-shadow: 0 8px 16px rgba(116, 185, 255, 0.4) !important;
  transform: translateY(-3px) !important;
}
.custom-btn-reset {
  white-space: nowrap;
  background:
    linear-gradient(
      145deg,
      #7f8c8d,
      #bdc3c7) !important;
  color: white !important;
  box-shadow: 0 6px 12px rgba(127, 140, 141, 0.3) !important;
}
.custom-btn-reset:hover {
  white-space: nowrap;
  background:
    linear-gradient(
      145deg,
      #bdc3c7,
      #7f8c8d) !important;
  box-shadow: 0 8px 16px rgba(189, 195, 199, 0.4) !important;
  transform: translateY(-3px) !important;
}
.custom-btn-filter:focus,
.custom-btn-reset:focus {
  outline: 2px solid rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2) !important;
}
.custom-link-button {
  padding: 10px 15px;
  margin-right: 10px;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;
  font-weight: bold;
  transition: all 0.3s ease;
}
.custom-link-button.active {
  color: black !important;
}
.custom-link-button.inactive {
  color: deepskyblue !important;
}
.custom-link-button:hover {
  color: #007bff !important;
  text-decoration: none;
}
.custom-link-button:focus {
  outline: 2px solid rgba(0, 123, 255, 0.5);
}
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dashboard-header .site-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0;
}
.dashboard-header .user-info {
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard-header .user-info span {
  margin-right: 10px;
}
.dashboard-header .user-info i {
  cursor: pointer;
  font-size: 1.2rem;
  transition: color 0.3s;
}
.dashboard-header .user-info i:hover {
  color: #e6e6e6;
}
.navbar {
  display: flex;
  align-items: center;
  margin-top: 15px;
  border-radius: 10px;
  color: white;
  padding: 5px 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
}
.navbar .nav-item {
  position: relative;
  margin-right: 20px;
  color: white;
}
.navbar .nav-item a {
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}
.navbar .nav-item a:hover {
  color: black;
}
.navbar .nav-item .dropdown {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #ffffff;
  color: #333;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 10;
}
.navbar .nav-item .dropdown a {
  display: block;
  padding: 10px 15px;
  color: #1a73e8;
  font-size: 15px !important;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;
}
.navbar .nav-item .dropdown a:hover {
  background-color: #f1f5ff;
  color: #0056b3;
}
.navbar .nav-item:hover .dropdown {
  display: block;
}
::ng-deep button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}
a {
  cursor: pointer !important;
}
.search-container {
  display: flex !important;
  margin-top: -20px;
  margin-right: 10px;
}
.search-label {
  font-size: 15px !important;
  font-weight: bold !important;
  margin-bottom: 5px !important;
  color: #333 !important;
}
.search-wrapper {
  position: relative !important;
  margin-top: -13px !important;
  width: 100% !important;
  max-width: 300px !important;
}
.search-input {
  width: 100% !important;
  padding: 10px 40px 10px 15px !important;
  border: 1px solid #ccc !important;
  border-radius: 25px !important;
  font-size: 15px !important;
  outline: none !important;
  transition: 0.3s !important;
}
.search-input:focus {
  border-color: #007bff !important;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5) !important;
}
.search-icon {
  position: absolute !important;
  right: 15px !important;
  top: 45% !important;
  transform: translateY(-50%) !important;
  color: #777 !important;
  font-size: 16px !important;
  cursor: pointer !important;
}
.search-input::placeholder {
  color: #aaa !important;
}
.form-container {
  display: flex;
  gap: 20px;
  width: 100%;
  justify-content: space-between;
}
.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.form-control,
.form-select {
  width: 100%;
  min-height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
td img {
  height: 40px !important;
  width: 40px !important;
  border-radius: 50% !important;
}
.no-data {
  text-align: center !important;
  font-size: 15px !important;
  font-weight: bold !important;
  color: #888 !important;
  padding: 20px !important;
  background-color: #f9f9f9 !important;
}
.n_btn {
  background-color: green !important;
  color: white !important;
  border-radius: 4px !important;
  padding: 5px 10px !important;
  border: none !important;
  cursor: pointer !important;
}
.n_btn:hover {
  opacity: 0.8 !important;
}
label,
div,
span,
button,
p {
  font-size: 15px !important;
}
.action-text {
  display: inline-block !important;
  cursor: pointer !important;
  font-size: 15px !important;
  padding: 5px 8px !important;
  text-decoration: none !important;
  font-weight: bold !important;
}
.action-text.delete {
  color: black !important;
}
.action-text.edit {
  color: black !important;
}
.action-text.fetch {
  color: black !important;
}
.action-text i {
  margin-right: 5px !important;
}
.action-text:hover {
  text-decoration: underline !important;
}
.fa-pen {
  color: cornflowerblue !important;
}
.fa-close {
  color: red !important;
}
.fa-download {
  color: lightgreen;
}
.disabled {
  color: #ccc;
  pointer-events: none;
}
#input-wrapper {
  display: flex !important;
  flex-direction: column !important;
}
.contact-input {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
}
.country-code {
  position: absolute !important;
  left: 12px !important;
  top: 45% !important;
  transform: translateY(-50%) !important;
  font-size: 15px !important;
  color: #333 !important;
  z-index: 10 !important;
}
.contact-number {
  padding-top: 9px !important;
  padding-left: 60px !important;
  height: 40px !important;
  font-size: 15px !important;
  width: 100% !important;
  border: 1px solid #ccc !important;
  border-radius: 5px !important;
  outline: none !important;
}
.contact-number:focus {
  border-color: #007bff !important;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5) !important;
}
.contact-number::placeholder {
  color: #999 !important;
  opacity: 1 !important;
}
.error-message {
  color: red !important;
  margin-left: 5px !important;
  margin-top: 5px !important;
  font-size: 14px !important;
}
/*# sourceMappingURL=namertune.component.css.map */
